export default "__VITE_ASSET__CMsiHf38__"